import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=100d4911&scoped=true&"
import script from "./CreateAccount.vue?vue&type=script&lang=ts&"
export * from "./CreateAccount.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=100d4911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100d4911",
  null
  
)

component.options.__file = "CreateAccount.vue"
export default component.exports